import {formatarValorComCasas} from "@/helpers/index";

export default (n, qtde_decimais = 2, qtde_caracteres = 6) => {
  const ranges = [
    { divider: 1e15, suffix: "P" },
    { divider: 1e12, suffix: "T" },
    { divider: 1e9, suffix: "G" },
    { divider: 1e6, suffix: "M" },
    { divider: 1e3, suffix: "k" },
  ];

  for (let i = 0; i < ranges.length; i++) {
    if (Math.abs(n) >= ranges[i].divider) {
      const valor = Math.round(n) / ranges[i].divider;

      if (valor < 0) {
        qtde_caracteres++;
      }

      return valor.toFixed(qtde_decimais)
        .toString()
        .substring(0, qtde_caracteres) + ranges[i].suffix;
    }
  }

  if (n == null) {
    n = "0.00";
  }

  return formatarValorComCasas(n, 0);
}
